import { OutstandingCompliance } from './compliance.model';

export class ComplianceStateModel {
  outstandingCompliance: OutstandingCompliance;
  userId: string;
  redirectUrl: string;
  successRedirectUrl: string;
}
